<template>
  <div>
    <h3>Edition de transporteur</h3>
    <div
      v-if="step == 0"
      class='transporteur'
    >
      <input
        v-model="transporteur.nom"
        type="text"
        placeholder="Nom du transporteur"
      >
      <textarea
        v-model="transporteur.description"
        type="text"
        placeholder="Description"
      />
      <label>File
        <input
          type="file"
          @change="handleFileUpload( $event )"
        >
      </label>
      <input
        v-model="transporteur.tracking_url"
        type="text"
        placeholder="URL de tracking"
      >
    </div>
    <div v-if="step == 1">
      <div
        class="forfait"
        v-for="(forfait, index) of forfaits"
        :key="index"
      >
        <input
          type="radio"
          name="forfait"
          :id="forfait.id"
          :value="forfait.id"
          v-model="transporteur.id_forfait_transport"
        >
        Forfait: #{{ forfait.id }}
        <div>
          Montant: {{ forfait.montant }}€
        </div>
        <div>
          Tranche: {{ forfait.tranche.libelle }}
        </div>
        <div>
          Zone: {{ forfait.zone.libelle }}
        </div>
      </div>
    </div>
    <div v-if="step == 2">
      <h4>Paramétrage</h4>
      <div class='parametrage-navigation'>
        <fieldset
          v-for="(param, indexParam) of parametrages"
          :key="indexParam"
        >
          <span class="label-param">
            {{ param.LIB }} :
          </span>
          <label>
            <input
              name="enable"
              type="checkbox"
              :id="param.VAL"
              :value="param.VAL"
              v-model="transporteur.params"
            >
            activer
          </label>
        </fieldset>
      </div>
      <div>
        <fieldset
          v-for="(option, indexOption) of options"
          :key="indexOption"
        >
          <span class="label-option">
            {{ option.nom }} :
          </span>
          <label>
            <input
              name="enable"
              type="checkbox"
              :id="option.nom"
              :value="option.valeur"
              v-model="transporteur.options"
            >
            {{ option.nom }}
          </label>
        </fieldset>
      </div>
    </div>
    <div class="buttons">
      <button
        type="reset"
        class="buttonIcon icon-cross"
        @click.prevent="cancel"
      >
        Annuler
      </button>
      <button
        class="buttonIcon icon-validate"
        @click.prevent="submit"
      >
        {{ submitLabel }}
      </button>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import axios from 'axios'

export default {
  computed: {
    ...mapGetters([
      'parametrages',
      'options'
    ])
  },
  props: {
    transporteur: {
      type: Object,
      default() {
        return {
          params: [],
          options: []
        }
      }
    },
    forfaits: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data: function() {
    return {
      submitLabel: 'Suivant',
      step: 0
    }
  },
  methods: {
    submit: function() {
      const finalStep = 2
      if(this.step < finalStep ) {
        this.step++
        if(this.step == finalStep) {
          this.submitLabel = 'Ajouter'
        }
      } else {
        if(this.isValid()) {
          console.log('emit validate add: ' + this.transporteur.nom)
          this.$emit('validate-add-transporteur', this.transporteur)
        } else {
          throw new CustomException(e, 'Transporteur invalide')
        }
      }
    },
    cancel: function() {
      this.resetStep()
      this.$emit('cancel-add-transporteur', this.transporteur.nom)
    },
    isValid: function() {
      if(this.transporteur.nom) {
        return true
      }
      return false
    },
    resetStep: function() {
      this.step = 0
      this.submitLabel = 'Suivant'
    },
    handleFileUpload( event ){
      let formData = new FormData()
      formData.append('logo', event.target.files[0])
      axios.post( '/service/transporteur/logo/upload',
                  formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                  }
      ).then(function() {
        console.log('SUCCESS!!')
      })
        .catch(function() {
          console.log('FAILURE!!')
        })
    }
  }
}
</script>
<style scoped>
  .transporteur input,
  .transporteur label {
    display: block;
  }

  .forfait {
    margin: 1em 0 1em 0;
  }

  input,
  label {
    display: inline-block;
  }

  .label-param {
    display: inline-block;
    width: 20%;
  }

</style>
